const errorHandler = (error) => {
  if (error?.response) {
    // Request made and server responded
    console.log("error.response", error.response);
    const { data, statusText } = error.response;

    const { error: data_error } = data || {};
    const { message: data_message } = data_error || {};

    let message;
    if (typeof data_message == "object") {
      for (const key in data_message) {
        let value = data_message[key];

        if (Array.isArray(value)) {
          value = value.reduce((_str, item) => {
            _str +=
              typeof item == "string" ? item : JSON.stringify(item) + " ,";
            return _str;
          }, "");
        }

        if (typeof value !== "string") {
          value = JSON.stringify(value);
        }

        if (message) {
          message += "-" + value;
        } else {
          message = value;
        }
      }
    }
    message = message || data_message || statusText;

    // Use a switch block to handle SQLSTATE errors
    switch (true) {
      case message.includes("Integrity constraint violation:") &&
          message.includes("orders.orders_reference_no_unique"):
        message = "Activity Type Prefix not set! please contact Administrator!";
        break;

      case message.includes("Integrity constraint violation:") &&
           message.includes("location_section_id"):
        message = "Location/Section is Required!";
        break;
    
      case message.includes("SQLSTATE[22001]"):
        message =
          "The data provided is too long for the column. Please check the length and try again!";
        break;
    
      case message.includes("SQLSTATE[23000]"):
        message =
          "The operation could not be completed due to a data integrity issue. Please check your input and try again!";
        break;
    
      case message.includes("SQLSTATE[42000]"):
        message =
          "The operation could not be completed due to a database syntax issue. Please contact Administrator!";
        break;
    
      // New case for handling other SQLSTATE errors
      case message.includes("SQLSTATE"):
        message =
          "An unknown database error occurred. Please contact the Administrator!";
        break;
    
      default:
        // message = message; // Retain the original message if no cases match
        break;
    }
    
    
    throw new Error(message);
  } else if (error?.request) {
    // The request was made but no response was received
    console.log("error.request:-", error.request);
    throw new Error("Network or System Error!");
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log("Unknown Error:", error);
    if (error?.message) throw new Error(error.message);
    else {
      throw error;
    }
  }
};

const getErrorMessage = (error) => {
  try {
    errorHandler(error);
  } catch (err) {
    console.error(err);
    return err?.message ?? "Unknown Error!";
  }
};

export { errorHandler, getErrorMessage };
